import React, { useRef, useState } from "react";
import { Upload, Loader2, X, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function ImageUpload({ value, onChange, testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${BACKEND_URL}${data.url}`);
      toast.success("Imagem carregada");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="mt-1 space-y-2" data-testid={testid}>
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <img src={value} alt="preview" className="w-16 h-16 rounded-lg object-cover border border-slate-200" data-testid={`${testid}-preview`} />
            <button type="button" onClick={() => onChange("")} data-testid={`${testid}-clear`}
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"><X className="w-3 h-3" /></button>
          </div>
        ) : (
          <div className="w-16 h-16 rounded-lg bg-slate-100 flex items-center justify-center text-slate-300"><ImageIcon className="w-6 h-6" /></div>
        )}
        <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading} data-testid={`${testid}-btn`}
          className="flex items-center gap-2 rounded-lg border border-th-blue text-th-blue px-3 py-2 text-sm font-medium hover:bg-th-blue/5 disabled:opacity-60">
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {uploading ? "A carregar..." : "Carregar imagem"}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={handleFile} data-testid={`${testid}-input`} />
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="ou colar URL da imagem"
        className="w-full text-xs rounded-md border border-slate-200 px-2 py-1.5 text-slate-500" data-testid={`${testid}-url`} />
    </div>
  );
}
